import { type WithOnChange, type WithValue } from "@common/declarations";
import React from "react";

const PlainText = (props: WithValue<string> & WithOnChange<string>) => (
  <div dangerouslySetInnerHTML={{ __html: props.value }}></div>
);

export default PlainText;
